import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      :host ::ng-deep .expense-header-text {
        white-space: normal;
        text-align: center;
      }
    `,
  ],
  template: `
    <div
      class="expense-header-text flex h-[48px] items-center justify-start space-x-[10px] border-b-2 border-aux-black pb-[1px]"
    >
      <div class="flex w-[132px] items-center justify-center">Primary Source</div>
      <div class="flex items-center justify-center"><aux-icon name="ChevronRight" /></div>
      <div class="flex w-[132px] items-center justify-center">Secondary Source</div>
      <div class="flex items-center justify-center"><aux-icon name="ChevronRight" /></div>
      <div class="flex w-[132px] items-center justify-center">Tertiary Source</div>
      <div class="flex items-center justify-center"><aux-icon name="ChevronRight" /></div>
      <div class="flex w-[132px] items-center justify-center">Quaternary Source</div>
    </div>
  `,
})
export class AgExpenseDefaultsHeaderComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  agInit() {}

  refresh(): boolean {
    return false;
  }
}
